import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Brewtopia",
    title: "Freshly Brewed Coffee, Just for You",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Brewtopia",
    title: "Warm Atmosphere & Cozy Ambiance",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Brewtopia",
    title: "Delicious Pastries & Specialty Drinks",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;